<!-- Component HTML Template -->
<!-- <div class="dashboard-container">
  <div class="welcome-header">
    <p>Please click the button below to start scanning</p>
  </div> -->

  <!-- Show Scan Now button only when camera is not active -->
  <!-- <button *ngIf="!cameraActive" class="scan-button" (click)="startScan()" [disabled]="isCameraLoading">
    {{ isCameraLoading ? 'Loading Camera...' : 'Scan Now' }}
  </button>

  <div class="loading-spinner" *ngIf="isCameraLoading">
    <div class="spinner"></div>
    <p>Accessing camera...</p>
  </div>

  <div class="error-message" *ngIf="cameraError">
    <p>{{ cameraError }}</p>
    <button class="retry-button" (click)="startScan()">Try Again</button>
  </div>

  <div class="camera-container" [ngClass]="{ 'active': cameraActive }">
    <webcam *ngIf="cameraStream"
      [trigger]="triggerObservable"
      [height]="500"
      [width]="500"
      [imageQuality]="1"
      (imageCapture)="handleImage($event)"
      (initError)="handleCameraInitError($event)"
      [videoOptions]="videoOptions">
    </webcam>
  </div> -->

  <!-- Camera control buttons container - only shown when camera is active -->
  <!-- <div class="camera-controls" *ngIf="cameraActive">
    <button class="captured" (click)="captureImage()">Capture</button>
    <button class="close-button" (click)="stopCamera()">Close</button>
  </div>
</div> -->


<!-- // dashboard.component.html -->
<div class="dashboard-container">
  <div class="welcome-header">
    <p>Please click the button below to start scanning</p>
  </div>

  <!-- Scan Now button for both web & mobile -->
  <button *ngIf="!cameraActive" class="scan-button" (click)="startScan()" [disabled]="isCameraLoading">
    {{ isCameraLoading ? 'Loading Camera...' : 'Scan Now' }}
  </button>

  <div class="loading-spinner" *ngIf="isCameraLoading">
    <div class="spinner"></div>
    <p>Accessing camera...</p>
  </div>

  <div class="error-message" *ngIf="cameraError">
    <p>{{ cameraError }}</p>
    <button class="retry-button" (click)="startScan()">Try Again</button>
  </div>

  <!-- Web camera preview -->
  <div class="camera-container" [ngClass]="{ 'active': cameraActive && platform === 'web' }">
    <webcam *ngIf="cameraStream && platform === 'web'"
      [trigger]="triggerObservable"
      [videoOptions]="videoOptions"
      (imageCapture)="handleImage($event)"
      (initError)="handleCameraInitError($event)">
    </webcam>
  </div>

  <!-- Mobile captured photo preview -->
  <div *ngIf="mobilePhoto" class="camera-container active">
    <img [src]="'data:image/jpeg;base64,' + mobilePhoto" alt="Captured" />
  </div>

  <!-- Camera control buttons -->
  <div class="camera-controls" *ngIf="cameraActive && platform === 'web'">
    <button class="captured" (click)="captureImage()">Capture</button>
    <button class="close-button" (click)="stopCamera()">Close</button>
  </div>
</div>
